import { TeamSpotProps } from '@optools/components/team-spot';
import { LoggerGamePipeline } from '@optools/services/operator-gateway/logger/types';
import {
  MediaContext,
  MediaFeedType,
  MediaType,
  PipelineStatus,
} from '@optools/services/operator-gateway/types/generated/graphql';
import { SchedulePipeline } from '@optools/services/operator-gateway/types/schedule';

export const getColorForPipeLineStatus = (status: PipelineStatus) => {
  switch (status) {
    case PipelineStatus.PENDING:
    case PipelineStatus.SCHEDULED:
    case PipelineStatus.PROVISIONED: {
      return 'info';
    }
    case PipelineStatus.ERROR: {
      return 'error';
    }
    case PipelineStatus.WARNING: {
      return 'warning';
    }
    case PipelineStatus.RUNNING: {
      return 'success';
    }
    default: {
      return 'default';
    }
  }
};

// Future note, this method operates on the assumption there will only ever be one video feed,
// if for example we start to see more video feeds (HD, etc.) we will need to adjust the logic here
// to be inline with the new feature.
export const getMediaId = (pipeline: SchedulePipeline | LoggerGamePipeline) => {
  return (
    pipeline.media.find(({ mediaType }) => mediaType === MediaType.VIDEO)?.id ??
    pipeline.media.find(({ mediaType }) => mediaType === MediaType.AUDIO)?.id ??
    ''
  );
};

export const hasVideoMedia = (pipeline: { media: Pick<MediaContext, 'mediaType'>[] }) => {
  return pipeline.media?.some((item) => item.mediaType === MediaType.VIDEO);
};

export const getTeamByFeedType = ({
  away,
  feedType,
  home,
}: {
  feedType: MediaFeedType;
  away: TeamSpotProps['team'];
  home: TeamSpotProps['team'];
}) => {
  switch (feedType) {
    case MediaFeedType.HOME: {
      return home;
    }
    case MediaFeedType.AWAY:
      return away;
    default:
      return null;
  }
};
